/** Trustpilot configuration and utilities */

export const TRUSTPILOT_INTEGRATION_KEY = process.env.NEXT_PUBLIC_TRUSTPILOT_INTEGRATION_KEY ?? "";
export const TRUSTPILOT_BUSINESS_UNIT_ID = process.env.NEXT_PUBLIC_TRUSTPILOT_BUSINESS_UNIT_ID ?? "";
export const TRUSTPILOT_ENABLED = process.env.NEXT_PUBLIC_TRUSTPILOT_ENABLED === "true";

export const TRUSTPILOT_INVITE_SDK_URL = "https://invitejs.trustpilot.com/tp.min.js";

/** Map app locales to Trustpilot locale format */
const LOCALE_MAP: Record<string, string> = {
	en: "en-GB",
	de: "de-DE",
	it: "it-IT",
	es: "es-ES",
	fr: "fr-FR",
	nl: "nl-NL",
	pt: "pt-PT",
	pl: "pl-PL",
};

export function getTrustpilotLocale(appLocale: string): string {
	return LOCALE_MAP[appLocale] ?? "en-GB";
}

/**
 * Call window.tp with retry if SDK hasn't loaded yet.
 * Retries up to 5 times with 500ms delay.
 */
export function callTrustpilot(command: "register" | "createInvitation", data: unknown, retries = 5): void {
	if (typeof window.tp === "function") {
		window.tp(command, data);
		return;
	}
	if (retries > 0) {
		setTimeout(() => callTrustpilot(command, data, retries - 1), 500);
	} else {
		console.warn(`[Trustpilot] window.tp not available after retries for "${command}"`);
	}
}
